import { categories } from '@/mocks/categories';
import CategoryCard from '@/components/base/CategoryCard';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-xs font-label uppercase tracking-[0.2em] text-foreground-500 mb-3">
            Browse Collection
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Shop by Category
            <br />
            <span className="text-primary-500">Find Your Style</span>
          </h2>
          <p className="mt-4 text-sm text-foreground-600 max-w-xl mx-auto">
            Explore our complete range of fashion categories. From shoes to accessories, 
            discover everything you need to elevate your wardrobe at Kaspreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <CategoryCard
              key={cat.id}
              name={cat.name}
              description={cat.description}
              url={cat.url}
              icon={cat.icon}
              image={cat.image}
            />
          ))}
        </div>
      </div>
    </section>
  );
}